<template>
	<iframe name="Iframe" frameborder="0" :src="`https://www.khl.top/#/activeData?token=${token}`" style="width: 100%;height: 100%;background:#fff;"></iframe>
</template>

<script>
	export default {
		data() {
			return {
				token:localStorage.getItem('jwt')
			}
		},
		methods: {
		},

		created() {

		},
		mounted() {
		},
	}
</script>

<style>
</style>